import React, { useState, useEffect } from 'react';
import {Link} from "react-router5";
import {useTranslation} from "react-i18next";
import { SmallLoader } from "../utils/loader";

import {
  ensureSubscribeAndUpdate,
  swRegistrationUpdate, updateFound,
  getRegistration
} from '../sw/sw_subscribe';

export function AppUpdateMenu() {
  const { t } = useTranslation();

  const [check_update_pending, setCheckUpdatePending] = useState(false);
  const [update_pending, setUpdatePending] = useState(false);

  const [registration, setRegistration] = useState(null);
  const [update_found, setUpdateFound] = useState(null);


  useEffect(() => {
    getRegistration().then(async (reg) => {
      setRegistration(reg);

      await swRegistrationUpdate();

      const update_found = await updateFound()

      setUpdateFound(update_found);
    }).catch((err) => {
      setRegistration(null);
    })
  }, [])


  const lookupForUpdate = async () => {
    setCheckUpdatePending(true);

    const update_found = await updateFound()
    setUpdateFound(update_found);

    setCheckUpdatePending(false);
  }

  const performApplicationUpdate = async () => {
    setUpdatePending(true);

    await ensureSubscribeAndUpdate();
    const update_found = await updateFound()
    setUpdateFound(update_found);

    setUpdatePending(false);
  }

  const reloadApplication = () => {
    window.location.href = "/desktop/settings/app_update";
  }


  return <div className={'MainMenuContainer'}>
    <div className={'topMainMenu'}>
	<Link routeName='settings' routeOptions={{reload: true}}>  <div className={'topMainBack'}></div></Link>
	<div className={'topMainTitle'}>{t('Application update')}</div>
    </div>

    { !registration &&
      <div className={'MainMenuItem'}>
        { t("No application update manager") }
      </div>
    }

    { registration &&
    <div className={'MainMenuItem'} onClick={lookupForUpdate} style={{cursor: "pointer"}}>
      { t("Check for an application update") }
      {
	check_update_pending
	? <SmallLoader />
	: <div className={'MainMenuItemUnchecked'} />
      }
    </div>
    }

    { update_found &&
    <div className={'MainMenuItem'} onClick={performApplicationUpdate} style={{cursor: "pointer"}}>
      { t("Perform application update") }
      {
	update_pending
	? <SmallLoader />
	: <div className={'MainMenuItemUnchecked'} />
      }
    </div>
    }

    <div className={'MainMenuItem'} onClick={reloadApplication} style={{cursor: "pointer"}}>
      { t("Reload application") }
      <div className={'MainMenuItemUnchecked'} />
    </div>
  </div>
}

